/**
 * Landing query for the Safety tab.
 *
 * For every `:ProtectiveFunction` it returns:
 *   - `function`           — the node itself
 *   - `line`               — the owning `(:Line)-[:HAS_PROTECTIVE_FUNCTION]->`
 *                            parent, if any
 *   - `site`               — Site from the owning Line or linked SRS section
 *   - `solver`             — the `[:SOLVED_BY]->(:LogicSolver)` logic solver
 *   - `section`            — the `[:IN_SECTION]->(:SrsSection)` classification
 *   - `sensorCount`        — distinct `[:SENSED_BY]->(:Equipment)` sensors
 *   - `finalElementCount`  — distinct `[:ACTUATES]->(:Equipment)` final elements
 *   - `implementedDiagrams` — `[:IMPLEMENTED_BY]->(:FunctionLogicDiagram)`
 *
 * Drained client-side via `drainCypherRows` to defeat the proxy's
 * silent auto-`LIMIT 100` cap.
 */
export const PLANT_PROTECTIVE_FUNCTIONS_CYPHER = `
            MATCH (pf:ProtectiveFunction)
            OPTIONAL MATCH (line:Line)-[:HAS_PROTECTIVE_FUNCTION]->(pf)
            OPTIONAL MATCH (site:Site)-[:HAS_LINE]->(line)
            OPTIONAL MATCH (pf)-[:IN_SECTION]->(srsSection:SrsSection)
            OPTIONAL MATCH (srsSection)-[:PART_OF]->(sectionSite:Site)
            WITH pf, line, site,
                 head(collect(distinct sectionSite)) AS sectionSiteCandidate,
                 head(collect(distinct srsSection)) AS section
            WITH pf, line, coalesce(site, sectionSiteCandidate) AS site, section
            OPTIONAL MATCH (pf)-[:SENSED_BY]->(sensor:Equipment)
            WITH pf, line, site, section, count(distinct sensor) AS sensorCount
            OPTIONAL MATCH (pf)-[:ACTUATES]->(fe:Equipment)
            WITH pf, line, site, section, sensorCount,
                 count(distinct fe) AS finalElementCount
            OPTIONAL MATCH (pf)-[:SOLVED_BY]->(solver:LogicSolver)
            OPTIONAL MATCH (pf)-[:IMPLEMENTED_BY]->(implFld:FunctionLogicDiagram)
            RETURN pf AS function,
                   line,
                   site,
                   solver,
                   section,
                   sensorCount,
                   finalElementCount,
                   collect(distinct implFld) AS implementedDiagrams
            ORDER BY toLower(coalesce(pf.name, pf.id))
            SKIP toInteger($skip) LIMIT toInteger($pageSize)
          `
